/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiCursorAWindowIcon16Light } from './UiCursorAWindowIcon16Light';
import { UiCursorAWindowIcon16Regular } from './UiCursorAWindowIcon16Regular';
import { UiCursorAWindowIcon16Solid } from './UiCursorAWindowIcon16Solid';
import { UiCursorAWindowIcon20Light } from './UiCursorAWindowIcon20Light';
import { UiCursorAWindowIcon20Regular } from './UiCursorAWindowIcon20Regular';
import { UiCursorAWindowIcon20Solid } from './UiCursorAWindowIcon20Solid';
import { UiCursorAWindowIcon24Regular } from './UiCursorAWindowIcon24Regular';
import { UiCursorAWindowIcon24Solid } from './UiCursorAWindowIcon24Solid';
import { UiCursorAWindowIcon32Regular } from './UiCursorAWindowIcon32Regular';
import { UiCursorAWindowIcon64Regular } from './UiCursorAWindowIcon64Regular';
var sizes = {
    16: {
        light: UiCursorAWindowIcon16Light,
        regular: UiCursorAWindowIcon16Regular,
        solid: UiCursorAWindowIcon16Solid,
    },
    20: {
        light: UiCursorAWindowIcon20Light,
        regular: UiCursorAWindowIcon20Regular,
        solid: UiCursorAWindowIcon20Solid,
    },
    24: {
        regular: UiCursorAWindowIcon24Regular,
        solid: UiCursorAWindowIcon24Solid,
    },
    32: {
        regular: UiCursorAWindowIcon32Regular,
    },
    64: {
        regular: UiCursorAWindowIcon64Regular,
    },
};
export var UiCursorAWindowIcon = forwardRef('UiCursorAWindowIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
